import { render } from "./ShowallTRND.vue?vue&type=template&id=36571c53&scoped=true"
import script from "./ShowallTRND.vue?vue&type=script&lang=js"
export * from "./ShowallTRND.vue?vue&type=script&lang=js"

import "./ShowallTRND.vue?vue&type=style&index=0&id=36571c53&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36571c53"]])

export default __exports__